
export default {
  name: 'AppStatusBadge',
  props: {
    status: Boolean,
    enabledString: {
      type: String,
      required: false,
      default: ''
    },
    disabledString: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    classList () {
      return this.status ? 'text-green-300 bg-green-300 bg-opacity-8' : 'text-red-300 bg-red-200 bg-opacity-8'
    }
  }
}
